import { render, staticRenderFns } from "./Municipalities.html?vue&type=template&id=3d32f6fc&"
import script from "./Municipalities.js?vue&type=script&lang=js&"
export * from "./Municipalities.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports